export const breadcrumbResolvers = {
  patient: ({ patient }) => patient.detailViewData,
  customer: ({ customer }) => customer.detailViewData,
  formulary: ({ customer }) => customer.customerAssignedFormulary,
  user: ({ user }) => user.detailViewData,
  sso: ({ user }) => user.detailSsoViewData,
  layout: ({ layouts }) => layouts.deatilLayout,
  form: ({ forms }) => forms.formDetailsData,
  support: ({ support }) => support.questions,
  assessment: ({ patient }) => patient.detailAssessment,
};
